import { render, staticRenderFns } from "./indexCommunity.vue?vue&type=template&id=1e4b82bf&scoped=true"
import script from "./indexCommunity.vue?vue&type=script&lang=js"
export * from "./indexCommunity.vue?vue&type=script&lang=js"
import style0 from "./indexCommunity.vue?vue&type=style&index=0&id=1e4b82bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4b82bf",
  null
  
)

export default component.exports